import { styled, Stack, Grid } from "@mui/material";
import { SIGNUP_COLORS } from "./tokens";

export const MainStack = styled(Stack)(() => ({
  minHeight: "100vh",
  height: "100vh",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#FFFFFF",
  overflow: "hidden",
  padding: 0,
  margin: 0,
}));

export const GridItemInfo = styled(Grid)(({ theme }) => ({
  position: "relative",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  background: `linear-gradient(180deg, ${SIGNUP_COLORS.backgroundGradient} 0%, rgba(255,255,255,0) 100%)`,
  overflow: "hidden",

  video: {
    position: "absolute",
    right: "-20%",
    top: 0,
    height: "100%",
    width: "auto",
    objectFit: "cover",
    zIndex: 0,
  },

  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

export const GridItemForm = styled(Grid)(({ theme }) => ({
  position: "relative",
  height: "100%",
  backgroundColor: "#FFFFFF",
  padding: 0,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: 0,
  },
}));
